import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { Button, Drawer, Select, AutoComplete, Row, Col, Collapse, Popover, Checkbox, Space, Input, Switch, Tag, Slider } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Filter, ChevronDown, CloseIcon, Search, ChevronUp, Minus, Plus, Check, Location, GoBack, CheckCircle } from '../../assets/icons';
import { sortData, sortDataWithoutFunded } from './SearchFilterData';
import useMediaQuery from '../../Hooks/useMediaQuery';
import './SearchFilter.scss';
import { debounce } from '../../utils';
import {
  fetchFiltersCitiesListAction,
  fetchFiltersPropertTypeListAction,
  fetchFiltersLeverageAction,
  fetchSearchHistoryAction,
  featchMarketPlaceSearchAction,
  postSearchHistoryAction,
} from '../../store/reducer/filtersSlice';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { PRIMARY_PROPERTY_LABELS } from '../../utils/constant';

const { Panel } = Collapse;

const FILTER_NAME = {
  LOCATION: 'location',
  PROPERTY_TYPE: 'property type',
  SORT_BY: 'sort by',
};

const SearchFilter = (props) => {
  const { filterOptions, apiIsSecondary, totalProperties } = props;
  const shouldLog = useRef(true);
  const {
    selectedLocation,
    setSelectedLocation,
    priceRange,
    setPriceRange,
    selectedPropertyType,
    setSelectedPropertyType,
    selectedLeverages,
    setSelectedLeverages,
    searchedLocation,
    setSearchedLocation,
    savedProperty,
    setSavedProperty,
    ownProperty,
    setOwnProperty,
    dividendPaidProperty,
    setdividendPaidProperty,
    sortType,
    setSortType,
    marketPlaceSearch,
    setMarketPlaceSearch,
    searchTerm,
    setSearchTerm,
    savedPropertyTemp,
    setSavedPropertyTemp,
    ownPropertyTemp,
    setOwnPropertyTemp,
    dividendPaidPropertyTemp,
    setdividendPaidPropertyTemp,
    tempSelectedProperty,
    setTempSelectedProperty,
    selectedLeveragesTemp,
    setSelectedLeveragesTemp,
    priceRangeTemp,
    setPriceRangeTemp,
    handleApplyFilter,
    tempselectedLocation,
    setTempSelectedLocation,
    handleResetAllFilters,
    isResetClick,
    setIsResetClick,
  } = filterOptions;
  const [drawerOpen, setDrawerOpen] = useState();
  const [openFilter, setOpenFilter] = useState('');
  const [sortByOpen, setSortByOpen] = useState(false);
  const [changeMaxPriceRange, setChangeMaxPriceRange] = useState(false);
  const [changesIntoMaxPriceRange, setChangesIntoMaxPriceRange] = useState(false);
  const [isScroll, setIsScroll] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchResult, setSearchResult] = useState([]);
  const [locationSearchValue, setLocationSearchValue] = useState('');
  const [searchTurmLocation, setSearchTurmLocation] = useState('');

  const dispatch = useDispatch();
  const citiesData = useSelector((state) => state.filters.cityData);
  const propertyTypeData = useSelector((state) => state.filters.propertyTypeData);
  const leverageData = useSelector((state) => state.filters.leverageData);
  const searchHistoryData = useSelector((state) => state.filters.searchHistoryData);
  const userProfileData = useSelector((state) => state.userData.userData);

  useMemo(() => {
    if (searchHistoryData?.data?.length > 0) {
      setSearchResult([]);
      if (!searchHistoryData?.search) {
        let optionsArray = searchHistoryData?.data?.map((item) => ({
          label: (
            <>
              <GoBack />
              <span>{item?.searchKey}</span>
            </>
          ),
          value: item?.searchKey,
        }));
        let resentSearchObject = {
          label: 'Recent Searches',
          options: optionsArray,
        };
        setSearchResult([resentSearchObject]);
        return [resentSearchObject];
      } else {
        let optionsArray;
        optionsArray = searchHistoryData?.data?.map((item) => {
          if (item?.property) {
            return {
              label: (
                <>
                  <LazyLoadImage alt={''} className='mr-8' width='20px' height='20px' src={item?.propertyTypeImageUrl} />
                  <span className='fw-600'>{item?.property}</span>
                </>
              ),
              value: item?.property,
            };
          }
          if (item?.city) {
            return {
              label: (
                <>
                  <Location verticalAlign='-8px' />
                  <span>city: </span>
                  <span className='fw-600'>{`${item?.city}, ${item?.stateCode}`}</span>
                </>
              ),
              value: item?.city,
            };
          }
          if (item?.state) {
            return {
              label: (
                <>
                  <Location verticalAlign='-8px' />
                  <span>state: </span>
                  <span className='fw-600'>{item?.state}</span>
                </>
              ),
              value: item?.state,
            };
          }
          return null;
        });
        let resentSearchObject;
        resentSearchObject = {
          label: 'Search Result',
          options: [...optionsArray],
        };
        setTimeout(() => {
          setSearchResult([resentSearchObject]);
        }, 5);
        return [resentSearchObject];
      }
    } else {
      setSearchResult([]);
    }
  }, [searchHistoryData]);

  const featchCities = async () => {
    await dispatch(fetchFiltersCitiesListAction({ page: 1, perPage: 10, isSecondary: apiIsSecondary }));
    await dispatch(fetchFiltersPropertTypeListAction({ isSecondary: apiIsSecondary }));
    await dispatch(fetchFiltersLeverageAction({ isSecondary: apiIsSecondary }));
    Object.keys(userProfileData).length > 0 && (await dispatch(fetchSearchHistoryAction({})));
  };

  useEffect(() => {
    if (shouldLog.current) {
      shouldLog.current = false;
      featchCities();
    }
  }, []);

  const onSearchLocationChange = async (e) => {
    setSearchedLocation(e.target.value);
    if (e.target.value.trim().length > 0) {
      await dispatch(
        fetchFiltersCitiesListAction({
          page: 1,
          perPage: 10,
          isSecondary: apiIsSecondary,
          searchText: e.target.value,
        })
      );
    } else {
      await dispatch(fetchFiltersCitiesListAction({ page: 1, perPage: 10, isSecondary: apiIsSecondary }));
    }
  };

  const onSearchLocationAllFilter = async (value) => {
    if (value.trim().length > 0) {
      await dispatch(fetchFiltersCitiesListAction({ page: 1, perPage: 10, isSecondary: apiIsSecondary, searchText: value }));
      setSearchedLocation(value);
    } else {
      await dispatch(fetchFiltersCitiesListAction({ page: 1, perPage: 10, isSecondary: apiIsSecondary }));
      setSearchedLocation('');
    }
  };

  const onSearchMarketplace = async (value) => {
    if (value.trim().length > 0) {
      await dispatch(
        featchMarketPlaceSearchAction({
          page: 1,
          perPage: 10,
          isSecondary: apiIsSecondary,
          search: value,
        })
      );
    }
    if (value === '') {
      Object.keys(userProfileData).length > 0 && (await dispatch(fetchSearchHistoryAction({})));
      handleApplyFilter(
        selectedLocation,
        savedProperty,
        ownProperty,
        dividendPaidProperty,
        selectedPropertyType,
        selectedLeverages,
        priceRange,
        sortType,
        value,
        apiIsSecondary
      );
    }
  };

  const onSearchChange = useCallback(debounce(onSearchLocationChange, 500), []);
  const onSearchLocation = useCallback(debounce(onSearchLocationAllFilter, 500), []);
  const onMarketPlaceSearch = useCallback(debounce(onSearchMarketplace, 500), []);
  const screenMD = useMediaQuery('(min-width: 1000px)');
  useEffect(() => {
    window.addEventListener('scroll', () => {
      setIsScroll(window.scrollY > 145);
    });
  }, []);

  const typeContent = (
    <>
      <Space direction='vertical' size={20} className='filterbar__type__options'>
        {React.Children.toArray(
          propertyTypeData?.data?.propertyTypes?.map((item) => (
            <Checkbox
              checked={selectedPropertyType.some((e) => e.propertyTypeId === item.propertyTypeId)}
              onClick={() => handleSelectPropertyTypeFilter(item)}
            >
              {item?.name} <span className='text-taupe-80'>({item?.propertyCount})</span>
            </Checkbox>
          ))
        )}
      </Space>
      {props.isSecondary ? (
        <div className='px-24'>
          <hr />
          <div className='py-24'>
            <Switch /> <span className='fz-16 ml-8 switch-lbl'>Properties I own</span>
          </div>
        </div>
      ) : (
        <>
          <hr />
          <Button
            type='text'
            className='w-100'
            disabled={!selectedPropertyType?.length}
            onClick={() => {
              setOpenFilter('');
              setIsResetClick(true);
              setSelectedPropertyType([]);
              setTempSelectedProperty([]);
              handleApplyFilter(
                selectedLocation,
                savedProperty,
                ownProperty,
                dividendPaidProperty,
                [],
                selectedLeverages,
                priceRange,
                sortType,
                marketPlaceSearch,
                apiIsSecondary
              );
            }}
          >
            Reset all
          </Button>
        </>
      )}
    </>
  );

  const locationContent = (
    <>
      <Input
        value={searchTurmLocation}
        onChange={(e) => {
          onSearchChange(e);
          setLocationSearchValue(e.target.value);
          setSearchTurmLocation(e.target.value);
        }}
        // value={searchTurmLocation}
        prefix={<Search size={18} />}
        placeholder='Filter properties by location'
      />
      <Space direction='vertical' size={20} className='filterbar__location__options'>
        {citiesData?.data?.cities.length > 0 ? (
          <>
            {citiesData?.data?.cities?.map((item) => (
              <Checkbox checked={selectedLocation?.some((e) => e.cityId === item.cityId)} onClick={() => handleSelectLocation(item)}>
                {`${item?.name}, ${item.state.code}`} <span className='text-taupe-80'>({item?.propertyCount})</span>
              </Checkbox>
            ))}
          </>
        ) : (
          <p>{locationSearchValue.trim().length ? `No result found for: "${locationSearchValue}"` : 'No result found'}</p>
        )}
      </Space>
      <Button
        type='text'
        className='w-100 reset-button'
        disabled={!selectedLocation?.length}
        onClick={async () => {
          setOpenFilter('');
          setSelectedLocation([]);
          setTempSelectedLocation([]);
          setSearchedLocation('');
          setLocationSearchValue('');
          setIsResetClick(true);
          await dispatch(fetchFiltersCitiesListAction({ page: 1, perPage: 10 }));
          handleApplyFilter(
            [],
            savedProperty,
            ownProperty,
            dividendPaidProperty,
            selectedPropertyType,
            selectedLeverages,
            priceRange,
            sortType,
            marketPlaceSearch,
            apiIsSecondary
          );
        }}
      >
        Reset all
      </Button>
    </>
  );

  const handleSelectLocation = async (value) => {
    if (!selectedLocation.some((e) => e.cityId === value.cityId)) {
      await setSelectedLocation((prevItem) => [...prevItem, value]);
      await setTempSelectedLocation((prevItem) => [...prevItem, value]);
      setSearchTurmLocation(value?.name);
      handleApplyFilter(
        [...selectedLocation, value],
        savedProperty,
        ownProperty,
        dividendPaidProperty,
        selectedPropertyType,
        selectedLeverages,
        priceRange,
        sortType,
        marketPlaceSearch,
        apiIsSecondary
      );
    } else {
      let updatedLocationArray = selectedLocation?.filter((item) => item.cityId !== value.cityId && item);
      await setSelectedLocation(updatedLocationArray);
      await setTempSelectedLocation(updatedLocationArray);
      setSearchTurmLocation('');
      handleApplyFilter(
        updatedLocationArray,
        savedProperty,
        ownProperty,
        dividendPaidProperty,
        selectedPropertyType,
        selectedLeverages,
        priceRange,
        sortType,
        marketPlaceSearch,
        apiIsSecondary
      );
    }
  };

  const handleSelectLocationAllFilter = async (value) => {
    if (!tempselectedLocation.some((e) => e.cityId === value.cityId)) {
      setSearchTurmLocation(value?.name);
      await setTempSelectedLocation((prevItem) => [...prevItem, value]);
    } else {
      setSearchTurmLocation('');
      let updatedLocationArray = tempselectedLocation?.filter((item) => item.cityId !== value.cityId && item);
      await setTempSelectedLocation(updatedLocationArray);
    }
  };

  const handleSelectPropertyTypeFilter = async (value) => {
    if (selectedPropertyType.some((e) => e.propertyTypeId === value.propertyTypeId)) {
      let updatedData = selectedPropertyType?.filter((item) => item?.propertyTypeId !== value?.propertyTypeId && item);
      setSelectedPropertyType(updatedData);
      setTempSelectedProperty(updatedData);
      handleApplyFilter(
        selectedLocation,
        savedProperty,
        ownProperty,
        dividendPaidProperty,
        updatedData,
        selectedLeverages,
        priceRange,
        sortType,
        marketPlaceSearch,
        apiIsSecondary
      );
    } else {
      setSelectedPropertyType((prevItem) => [...prevItem, value]);
      setTempSelectedProperty((prevItem) => [...prevItem, value]);
      handleApplyFilter(
        selectedLocation,
        savedProperty,
        ownProperty,
        dividendPaidProperty,
        [...selectedPropertyType, value],
        selectedLeverages,
        priceRange,
        sortType,
        marketPlaceSearch,
        apiIsSecondary
      );
    }
  };

  const handleSelectPropertyTypeAllFilter = async (value) => {
    if (tempSelectedProperty.some((e) => e.propertyTypeId === value.propertyTypeId)) {
      let updatedData = tempSelectedProperty?.filter((item) => item?.propertyTypeId !== value?.propertyTypeId && item);
      setTempSelectedProperty(updatedData);
    } else {
      setTempSelectedProperty((prevItem) => [...prevItem, value]);
    }
  };

  const handleSelectLeveragesFilter = async (value) => {
    if (!selectedLeveragesTemp.includes(value)) {
      setSelectedLeveragesTemp((prevItem) => [...prevItem, value]);
    } else {
      let updatedData = selectedLeveragesTemp?.filter((item) => item !== value && item);
      setSelectedLeveragesTemp(updatedData);
    }
  };
  return (
    <>
      <div className={isScroll ? 'filterbar-wrapper sticky' : 'filterbar-wrapper'}>
        <div className='container-fluid filterbar'>
          <p className='w-100 filterbar__title'>{props.page}</p>
          <Button
            className='filterbar__trigger--mobile'
            icon={<Filter size={18} verticalAlign='-3px' marginRight='8px' />}
            onClick={() => setDrawerOpen('mobile')}
          >
            Filters
          </Button>
          <div id='search-search'></div>
          {/* <div id='type-search'></div> */}
          <div className='filterbar__search filterbar__search--desktop'>
            <AutoComplete
              allowClear
              popupClassName='filterbar__search__dropdown'
              getPopupContainer={() => document.getElementById('search-search')}
              onSelect={async (value) => {
                Object.keys(userProfileData).length > 0 && (await dispatch(postSearchHistoryAction({ searchKey: value })));
                setMarketPlaceSearch(value);
                handleApplyFilter(
                  selectedLocation,
                  savedProperty,
                  ownProperty,
                  dividendPaidProperty,
                  selectedPropertyType,
                  selectedLeverages,
                  priceRange,
                  sortType,
                  value,
                  apiIsSecondary
                );
              }}
              dropdownMatchSelectWidth={false}
              clearIcon={<span className='clear'>clear</span>}
              options={searchResult}
              notFoundContent={
                <>
                  {marketPlaceSearch.trim().length ? (
                    <>
                      <span>No result found for: </span>
                      <span className='fw-600'>{`"${marketPlaceSearch}"`}</span>
                    </>
                  ) : (
                    <>
                      <span>No result found</span>
                    </>
                  )}
                </>
              }
              value={searchTerm}
              onChange={(val) => {
                setSearchTerm(val);
                setMarketPlaceSearch(val);
              }}
              placeholder='Search by Name, City, State'
              onSearch={onMarketPlaceSearch}
            />
            <Search className='search-icon' size={18} />
          </div>

          <Popover
            open={openFilter === FILTER_NAME.PROPERTY_TYPE}
            className={'filterbar__type__trigger'}
            popupClassName='filterbar__type'
            getPopupContainer={() => document.getElementById('search-search')}
            content={typeContent}
            placement='bottomLeft'
            trigger='click'
            onOpenChange={() => setOpenFilter(openFilter === FILTER_NAME.PROPERTY_TYPE ? '' : FILTER_NAME.PROPERTY_TYPE)}
          >
            <Button className='ml-8 btn-small'>
              Property type{' '}
              {openFilter === FILTER_NAME.PROPERTY_TYPE ? (
                <ChevronUp size={18} marginLeft='8px' verticalAlign='-4px' />
              ) : (
                <ChevronDown size={18} marginLeft='8px' verticalAlign='-4px' />
              )}
            </Button>
          </Popover>
          {props.isSecondary ? (
            <></>
          ) : (
            <>
              <Popover
                open={openFilter === FILTER_NAME.LOCATION}
                popupClassName='filterbar__location'
                className='filterbar__type__trigger'
                getPopupContainer={() => document.getElementById('search-search')}
                content={locationContent}
                placement='bottomLeft'
                trigger='click'
                onOpenChange={async () => {
                  setOpenFilter(openFilter === FILTER_NAME.LOCATION ? '' : FILTER_NAME.LOCATION);
                  setSearchTurmLocation('');
                  await dispatch(fetchFiltersCitiesListAction({ page: 1, perPage: 10, isSecondary: apiIsSecondary }));
                }}
              >
                <Button className='ml-8 btn-small'>
                  Location{' '}
                  {openFilter === FILTER_NAME.LOCATION ? (
                    <ChevronUp size={18} marginLeft='8px' verticalAlign='-4px' />
                  ) : (
                    <ChevronDown size={18} marginLeft='8px' verticalAlign='-4px' />
                  )}
                </Button>
              </Popover>
              <Button
                className='btn-small ml-8 filterbar__trigger--desktop'
                icon={<Filter size={18} verticalAlign='-3px' marginRight='8px' />}
                onClick={() => setDrawerOpen('mobile')}
              >
                All Filters
              </Button>
            </>
          )}
          <p className='property-count fw-600'>{`${totalProperties} properties`}</p>
          {props.isSecondary ? (
            <></>
          ) : (
            <Select
              className='sort with-check'
              defaultValue='newest'
              placement='bottomRight'
              popupClassName='sort__dropdown with-check'
              onDropdownVisibleChange={() => setSortByOpen(!sortByOpen)}
              onClick={() => setOpenFilter(FILTER_NAME.SORT_BY)}
              onSelect={(value) => {
                setSortType(value);
                handleApplyFilter(
                  selectedLocation,
                  savedProperty,
                  ownProperty,
                  dividendPaidProperty,
                  selectedPropertyType,
                  selectedLeverages,
                  priceRange,
                  value,
                  marketPlaceSearch,
                  apiIsSecondary
                );
              }}
              getPopupContainer={() => document.getElementById('search-search')}
              dropdownMatchSelectWidth={false}
              value={sortType}
              suffixIcon={
                sortByOpen ? <ChevronUp color='#1a1519' size={18} marginLeft='8px' /> : <ChevronDown color='#1a1519' size={18} marginLeft='8px' />
              }
              menuItemSelectedIcon={<CheckCircle color='#8A4743' verticalAlign='-8px' />}
              options={apiIsSecondary ? sortDataWithoutFunded : sortData}
            />
          )}
        </div>
        <Drawer
          className='filter__drawer'
          open={drawerOpen === 'mobile'}
          footer={
            <Row gutter={16}>
              <Col span={12}>
                <Button
                  onClick={() => {
                    handleResetAllFilters(apiIsSecondary);
                    setDrawerOpen(null);
                  }}
                  className='w-100 p-0'
                >
                  Reset All
                </Button>
              </Col>
              <Col span={12}>
                <Button
                  onClick={() => {
                    setSelectedPropertyType(tempSelectedProperty);
                    setSelectedLocation(tempselectedLocation);
                    setSavedProperty(savedPropertyTemp);
                    setOwnProperty(ownPropertyTemp);
                    setdividendPaidProperty(dividendPaidPropertyTemp);
                    setSearchTurmLocation('');
                    setSelectedLeverages(selectedLeveragesTemp);
                    setPriceRange(priceRangeTemp?.[0] > priceRangeTemp?.[1] ? [priceRangeTemp?.[1], priceRangeTemp?.[0]] : priceRangeTemp);
                    priceRangeTemp?.[0] > priceRangeTemp?.[1] && setPriceRangeTemp([priceRangeTemp?.[1], priceRangeTemp?.[0]]);
                    handleApplyFilter(
                      tempselectedLocation,
                      savedPropertyTemp,
                      ownPropertyTemp,
                      dividendPaidPropertyTemp,
                      tempSelectedProperty,
                      selectedLeveragesTemp,
                      priceRangeTemp?.[0] > priceRangeTemp?.[1] ? [priceRangeTemp?.[1], priceRangeTemp?.[0]] : priceRangeTemp,
                      sortType,
                      searchTerm,
                      apiIsSecondary
                    );
                    setDrawerOpen(null);
                  }}
                  className='w-100 p-0'
                  type='primary'
                >
                  Apply
                </Button>
              </Col>
            </Row>
          }
          onClose={() => {
            setDrawerOpen(null);
            setTempSelectedProperty(selectedPropertyType);
            setTempSelectedLocation(selectedLocation);
            setSavedPropertyTemp(savedProperty);
            setOwnPropertyTemp(ownProperty);
            setdividendPaidPropertyTemp(dividendPaidProperty);
            setSelectedLeveragesTemp(selectedLeverages);
            setPriceRangeTemp(priceRange);
          }}
          title={<h5 className='mb-0 text-center fz-20 fw-700'>All filters</h5>}
          closeIcon={<CloseIcon />}
        >
          <div className='filterbar__search filterbar__search--mobile'>
            <Search className='search-icon' size={18} />
            <AutoComplete
              className='w-100'
              allowClear
              dropdownMatchSelectWidth={false}
              clearIcon={<span className='clear'>clear</span>}
              options={searchResult}
              onSelect={async (value) => {
                setMarketPlaceSearch(value);
                Object.keys(userProfileData).length > 0 && (await dispatch(postSearchHistoryAction({ searchKey: value })));
              }}
              value={searchTerm}
              notFoundContent={
                <>
                  {marketPlaceSearch.trim().length ? (
                    <>
                      <span>No result found for: </span>
                      <span className='fw-600'>{`"${marketPlaceSearch}"`}</span>
                    </>
                  ) : (
                    <>
                      <span>No result found</span>
                    </>
                  )}
                </>
              }
              onChange={(val) => {
                setSearchTerm(val);
                setMarketPlaceSearch(val);
              }}
              onSearch={onMarketPlaceSearch}
              placeholder='Search by Name, City, State'
            />
          </div>

          <div className='filter-options mt-24'>
            <div className='filter-options__item'>
              <Switch checked={savedPropertyTemp} onClick={() => setSavedPropertyTemp(!savedPropertyTemp)} />{' '}
              <span className='ml-8'>Saved properties</span>
            </div>
            <div className='filter-options__item'>
              <Switch checked={ownPropertyTemp} onClick={() => setOwnPropertyTemp(!ownPropertyTemp)} /> <span className='ml-8'>Properties I own</span>
            </div>
            <div className='filter-options__item'>
              <Switch checked={dividendPaidPropertyTemp} onClick={() => setdividendPaidPropertyTemp(!dividendPaidPropertyTemp)} />{' '}
              <span className='ml-8'>Currently paying dividends</span>
            </div>
          </div>

          <hr className='hr' />

          <Collapse
            bordered={false}
            expandIconPosition='end'
            expandIcon={({ isActive }) => (isActive ? <Minus marginRight='-15px' /> : <Plus marginRight='-15px' />)}
          >
            {!screenMD && (
              <Panel header={<p className='subhead-3 mb-0'>Sort by</p>} key='1'>
                <div className='filter-options'>
                  <Space direction='vertical' size={24}>
                    <div
                      className='fz-16 cursor-pointer'
                      onClick={() => {
                        setSortType('Newest');
                      }}
                    >
                      <Check marginRight='14px' color={sortType === 'Newest' ? '#8A4743' : '#ffffff'} />
                      Newest
                    </div>
                    <div
                      className='fz-16 cursor-pointer'
                      onClick={() => {
                        setSortType('Trending');
                      }}
                    >
                      <Check marginRight='14px' color={sortType === 'Trending' ? '#8A4743' : '#ffffff'} />
                      Trending
                    </div>
                    {!apiIsSecondary && (
                      <div
                        className='fz-16 cursor-pointer'
                        onClick={() => {
                          setSortType('Almost funded');
                        }}
                      >
                        <Check marginRight='14px' color={sortType === 'Almost funded' ? '#8A4743' : '#ffffff'} />
                        Almost funded
                      </div>
                    )}
                    <div
                      className='fz-16 cursor-pointer'
                      onClick={() => {
                        setSortType('Lowest price');
                      }}
                    >
                      <Check marginRight='14px' color={sortType === 'Lowest price' ? '#8A4743' : '#ffffff'} />
                      Lowest price
                    </div>
                    <div
                      className='fz-16 cursor-pointer'
                      onClick={() => {
                        setSortType('Highest price');
                      }}
                    >
                      <Check marginRight='14px' color={sortType === 'Highest price' ? '#8A4743' : '#ffffff'} />
                      Highest price
                    </div>
                  </Space>
                </div>
              </Panel>
            )}

            <Panel header={<p className='subhead-3 mb-0'>Property type</p>} key='2'>
              <Space direction='vertical' size={24} className='filter-options'>
                {React.Children.toArray(
                  propertyTypeData?.data?.propertyTypes?.map((item) => (
                    <Checkbox
                      checked={tempSelectedProperty.some((e) => e.propertyTypeId === item.propertyTypeId)}
                      onClick={() => handleSelectPropertyTypeAllFilter(item)}
                    >
                      {item?.name} <span className='text-taupe-80'>({item?.propertyCount})</span>
                    </Checkbox>
                  ))
                )}
              </Space>
            </Panel>
            <Panel header={<p className='subhead-3 mb-0'>Location</p>} key='3'>
              <div className='filterbar__search--location'>
                <div id='location-anchor' />
                <Search className='search-icon' size={20} />
                <AutoComplete
                  className={isSearchOpen ? 'open w-100' : 'close w-100'}
                  allowClear
                  dropdownMatchSelectWidth={false}
                  getPopupContainer={() => document.getElementById('location-anchor')}
                  clearIcon={<span className='clear'>clear</span>}
                  value={searchTurmLocation}
                  options={
                    citiesData?.data?.cities.length > 0
                      ? citiesData?.data?.cities?.map((item) => ({
                        label: (
                          <Checkbox
                            checked={tempselectedLocation.some((e) => e.cityId === item.cityId)}
                            onClick={() => { handleSelectLocationAllFilter(item); setSearchTurmLocation('') }}
                          >
                            {`${item?.name}, ${item.state.code}`} <span className='text-taupe-80'>({item?.propertyCount})</span>
                          </Checkbox>
                        ),
                        value: item?.cityId,
                      }))
                      : []
                  }
                  notFoundContent={
                    <>
                      {searchedLocation.trim().length ? (
                        <>
                          <span>No result found for: </span>
                          <span className='fw-600'>{`"${searchedLocation}"`}</span>
                        </>
                      ) : (
                        <>
                          <span>No result found</span>
                        </>
                      )}
                    </>
                  }
                  onClick={()=>{setSearchTurmLocation('')}}
                  onChange={(value) => setSearchTurmLocation(value)}
                  popupClassName='filter-location-search'
                  onDropdownVisibleChange={() => setIsSearchOpen(!isSearchOpen)}
                  onSelect={(e) => e.preventDefault()}
                  placeholder='Search by Name, City, State'
                  onSearch={onSearchLocation}
                />
              </div>
              <div className='selected-locations'>
                {tempselectedLocation?.map((item) => (
                  <Tag closeIcon={<CloseIcon onClick={() => handleSelectLocationAllFilter(item)} size={20} color='#8A4743' />} closable>
                    {item?.name}
                  </Tag>
                ))}
              </div>
            </Panel>
            <Panel header={<p className='subhead-3 mb-0'>{PRIMARY_PROPERTY_LABELS.SHARE_PRICE}</p>} key='4'>
              <div className='price-chart'>
                <Slider
                  range
                  min={0}
                  max={10000}
                  value={priceRangeTemp}
                  defaultValue={[0, 10000]}
                  onChange={(value) => {
                    value[1] < 10000 && (setChangeMaxPriceRange(true) || setChangesIntoMaxPriceRange(true) || setIsResetClick(false));
                    setPriceRangeTemp(value);
                  }}
                  marks={{ 0: `$${priceRangeTemp?.[0]}`, 100: `$${priceRangeTemp?.[1]}` }}
                />
                <div className='price-chart__range'>
                  <Input
                    value={priceRangeTemp?.[0] === 0 ? undefined : priceRangeTemp?.[0]}
                    onChange={(e) => {
                      if (Number(e.target.value) > 10000 && Number(e.target.value) > priceRangeTemp?.[1]) {
                        e.preventDefault();
                      } else {
                        Number(e.target.value.replace(/[^0-9]/g, '')) !== 0 &&
                          Number(e.target.value.replace(/[^0-9]/g, '')) < 10000 &&
                          setChangeMaxPriceRange(true);
                        setPriceRangeTemp([Number(e.target.value.replace(/[^0-9]/g, '')), priceRangeTemp?.[1]]);
                      }
                    }}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    maxLength={priceRangeTemp?.[0] === 9999 ? '4' : '5'}
                    placeholder='Enter min'
                  />
                  <div className='divider' />
                  <Input
                    value={
                      !isResetClick ? (changeMaxPriceRange ? (changesIntoMaxPriceRange ? priceRangeTemp?.[1] : undefined) : undefined) : undefined
                    }
                    onChange={(e) => {
                      setIsResetClick(false);
                      if (Number(e.target.value) > 10000) {
                        e.preventDefault();
                      } else {
                        setChangeMaxPriceRange(true);
                        setChangesIntoMaxPriceRange(true);
                        setPriceRangeTemp([priceRangeTemp?.[0], Number(e.target.value.replace(/[^0-9]/g, ''))]);
                      }
                    }}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    placeholder='Enter max'
                    maxLength={priceRangeTemp?.[1] === 9999 ? '4' : '5'}
                  />
                </div>
              </div>
            </Panel>
            <Panel header={<p className='subhead-3 mb-0'>Leverage</p>} key='5'>
              <Space direction='vertical' size={24} className='filter-options'>
                {leverageData?.data?.countAt25 > 0 && (
                  <Checkbox checked={selectedLeveragesTemp.includes('>=0-<25')} onClick={() => handleSelectLeveragesFilter('>=0-<25')}>
                    0%-{'<'}25% <span className='text-taupe-80'>({leverageData?.data?.countAt25})</span>
                  </Checkbox>
                )}
                {leverageData?.data?.countAt50 > 0 && (
                  <Checkbox checked={selectedLeveragesTemp.includes('>=25-<50')} onClick={() => handleSelectLeveragesFilter('>=25-<50')}>
                    25%-{'<'}50% <span className='text-taupe-80'>({leverageData?.data?.countAt50})</span>
                  </Checkbox>
                )}
                {leverageData?.data?.countAt75 > 0 && (
                  <Checkbox checked={selectedLeveragesTemp.includes('>=50-<75')} onClick={() => handleSelectLeveragesFilter('>=50-<75')}>
                    50%-{'<'}75% <span className='text-taupe-80'>({leverageData?.data?.countAt75})</span>
                  </Checkbox>
                )}
                {leverageData?.data?.countAt100 > 0 && (
                  <Checkbox checked={selectedLeveragesTemp.includes('>=75-<=100')} onClick={() => handleSelectLeveragesFilter('>=75-<=100')}>
                    75%-{'<'}100% <span className='text-taupe-80'>({leverageData?.data?.countAt100})</span>
                  </Checkbox>
                )}
              </Space>
            </Panel>
          </Collapse>
        </Drawer>
      </div>
    </>
  );
};

export default SearchFilter;
